export default __webpack_public_path__ + "static/img-3-337cfc33ee8ab3dfdd998ecbc1ff339a.png";